export const localeSort = (
  a: string,
  b: string,
  locale?: string | string[],
  options: Intl.CollatorOptions = { sensitivity: "accent", numeric: true },
) => a.replace(/\s+/g, "").localeCompare(b.replace(/\s+/g, ""), locale, options);
